import { render } from "./FolderTopMatter.vue?vue&type=template&id=1fb84e22&scoped=true&ts=true"
import script from "./FolderTopMatter.vue?vue&type=script&lang=ts"
export * from "./FolderTopMatter.vue?vue&type=script&lang=ts"

import "./FolderTopMatter.vue?vue&type=style&index=0&id=1fb84e22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb84e22"]])

export default __exports__